import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 5px;
  width: 100%;
  justify-content: center;
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-weight: bold;
  line-height: 22px;
  white-space: pre;
`;
